import React from 'react';

import { StaticReactDataTable } from '@metarouter-private/mr-mui';

import customStyles from './customStyles';

export default function PipelineOverviewStaticTable(props) {
  return <StaticReactDataTable {...props} customStyles={customStyles} />;
}
